import { useState, useEffect, useMemo, useCallback } from 'react';
import { submitContactMessage } from '../services/api';

function useContactOverlay({ activeOverlay, authenticated, t }) {
  const [contactSubject, setContactSubject] = useState('');
  const [contactBody, setContactBody] = useState('');
  const [contactSubmitting, setContactSubmitting] = useState(false);
  const [contactSuccess, setContactSuccess] = useState(false);
  const [contactError, setContactError] = useState(null);

  useEffect(() => {
    if (activeOverlay !== 'contacts') {
      setContactSubject('');
      setContactBody('');
      setContactSuccess(false);
      setContactError(null);
      setContactSubmitting(false);
    }
  }, [activeOverlay]);

  const contactWordCount = useMemo(() => {
    return contactBody.split(/\s+/).filter((word) => word.length > 0).length;
  }, [contactBody]);

  const handleContactSubjectChange = useCallback((value) => {
    setContactSubject(value.slice(0, 30));
  }, []);

  const handleContactBodyChange = useCallback((value) => {
    const words = value.split(/\s+/).filter((word) => word.length > 0);
    if (words.length <= 500 || value.length < contactBody.length) {
      setContactBody(value);
    }
  }, [contactBody.length]);

  const handleContactSubmit = useCallback(async (event) => {
    event.preventDefault();

    if (!authenticated) {
      setContactError(t('contact_sign_in_required'));
      return;
    }

    setContactSubmitting(true);
    setContactError(null);

    try {
      await submitContactMessage(contactSubject, contactBody);
      setContactSuccess(true);
    } catch (err) {
      const errorMsg = err.response?.data?.error || t('contact_send_failed');
      setContactError(errorMsg);
    } finally {
      setContactSubmitting(false);
    }
  }, [authenticated, contactBody, contactSubject, t]);

  return {
    contactSuccess,
    contactSubject,
    contactBody,
    contactSubmitting,
    contactError,
    contactWordCount,
    handleContactSubjectChange,
    handleContactBodyChange,
    handleContactSubmit,
  };
}

export default useContactOverlay;
